systemStatus.classy.controller({
  name: 'SystemStatusController',
  inject: ['$scope', '$rootScope', 'HelpSystemModelService', 'SchoolModelService'],
  init: function()
  {
    this.$.SchoolModelService = this.SchoolModelService;
    this.$.HelpSystemModelService = this.HelpSystemModelService;

    this.$rootScope.model = this.SchoolModelService;
    this.$.item = this.SchoolModelService.data[0];
    this.$.minDate = new Date();
    this.$.systemStatusOptionEnable = this.SchoolModelService.data[0].systemStatusOptionEnable;

    //convert auto_wake to Date object, initialize wake_date flag
    //this.$.item.auto_wake = this.$.item.auto_wake=='1970-01-01' ? new Date('1970-01-01') : new Date(this.$.item.auto_wake);
    if (this.$.item.auto_wake == '0000-00-00' || this.$.item.auto_wake <= this.$.minDate) {
      this.$.wake_date = 0;
      this.$.minDate = '0000-00-00';
      if (this.$.item.auto_wake!=='0000-00-00')
        this.$.item.auto_wake = '0000-00-00';
    }
    else {
      this.$.wake_date = 1;
    }
    //this.changeautoawake(this.$.wake_date)
  },
  changeautoawake: function(checkbox) //check or uncheck auto awake flag, initialize Date object
  {
    if (checkbox==1) { //
      this.$.minDate = new Date();
      this.$.item.auto_wake = new Date();
    }
    else {
      this.$.item.auto_wake = '0000-00-00';
    }
  },
  systemToggle: function() //check or uncheck system status, reset auto-wake data
  {
    this.$.wake_date = 0;
    this.$.item.auto_wake = '0000-00-00';
  },
  formatDate: function(date)
  {
    var newd = new Date(date);
    return newd.toISOString().slice(0, 10);
  },
  submit: function(scope, instance, form)
  {
    if (form.$valid)
    {
      var data = angular.copy(this.$.item); //copy data to new object
      if (data.auto_wake!=='0000-00-00')
        data.auto_wake = this.formatDate(data.auto_wake); //convert from Date to string
      instance.options.factor  = .3;
      this.SchoolModelService.put(this.id, data, instance).then(function (response) {

      });
    }
    else
    {
      instance.stop(-1);
    }
  },
  successSave: function(scope, instance, callback) 
  {
    this.SchoolModelService.set(this.SchoolModelService.data);
    if (typeof callback !== 'undefined')
      callback();
  }
});
